export default __webpack_public_path__ + "static/media/jaipur1.42ce5ea5.jpg";